export const chartTypes = {
  AREA: "area",
  LINE: "line",
  BUBBLE: "bubble",
  COLUMN: "column",
  VENN: "venn",
  PIE: "pie",
  SCATTER: "scatter",
} as const;

/**
 * @deprecated replaced by "ChartType" which is a more strict type
 * */
export type TChartType = string;

export type ChartType = (typeof chartTypes)[keyof typeof chartTypes];
